import indexApi from './mixins/indexApi.js'
const resource = '/cv_processes/'

export const cvProcessRepository = (axios) => ({
  async index(params) {
    return await indexApi(axios, resource, params)
  }
})
